import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAdditionalProps, datePropType } from '@eb/eds-utils';

import RangePickerController from './_internal/RangePickerController';
import * as constants from './constants';

import './datePicker.scss';

export default class InlineDateRangePicker extends PureComponent {
    static propTypes = {
        /**
         * Initial date
         */
        defaultValue: PropTypes.shape(constants.RANGE_VALUE),
        /**
         * Current selected date
         */
        value: PropTypes.shape(constants.RANGE_VALUE),
        /**
         * Calendar color scheme
         */
        color: PropTypes.oneOf(constants.COLOR_PROP),
        /**
         * Minimum date that can be chosen
         */
        minDate: datePropType,
        /**
         * Maximum date that can be chosen
         */
        maxDate: datePropType,
        /**
         * Set error state
         */
        hasError: PropTypes.bool,
        /**
         * {function} for handling date selection
         */
        onChange: PropTypes.func,
        /**
         * {function} onFocus
         */
        onFocus: PropTypes.func,
        /**
         * The calendar should open focused on the passed in option.
         * Available options: startDate, endDate
         */
        initialFocusedInput: PropTypes.oneOf(constants.INITIAL_FOCUS),
    };

    static defaultProps = {
        color: constants.BLUE_COLOR,
    };

    constructor(props) {
        super(props);

        const { initialFocusedInput, defaultValue, value } = props;

        let startDate = null;
        let endDate = null;

        if (defaultValue) {
            startDate = defaultValue.startDate;
            endDate = defaultValue.endDate;
        }

        if (value) {
            startDate = value.startDate;
            endDate = value.endDate;
        }

        this.state = {
            startDate,
            endDate,
            focusedInput: initialFocusedInput,
        };
    }

    componentWillReceiveProps({ value = {} }) {
        this.setState(({ startDate, endDate }) => {
            const { startDate: newStartDate, endDate: newEndDate } = value;
            let startDateToReturn = startDate;
            let endDateToReturn = endDate;

            if (newStartDate && newStartDate !== startDate) {
                startDateToReturn = newStartDate;
            }

            if (newEndDate && newEndDate !== endDate) {
                endDateToReturn = newEndDate;
            }

            return { startDate: startDateToReturn, endDate: endDateToReturn };
        });
    }

    _handleFocus = (focusedInput) => {
        const { onFocus } = this.props;
        const { startDate, endDate } = this.state;
        const newFocusedInput = focusedInput ? focusedInput : 'startDate';

        this.setState({ focusedInput: newFocusedInput }, () => {
            if (onFocus) {
                onFocus({ startDate, endDate, focusedInput });
            }
        });
    };

    _handleDatesChange = ({ startDate, endDate }) => {
        const { onChange } = this.props;

        this.setState({ startDate, endDate }, () => {
            if (onChange) {
                onChange({ startDate, endDate });
            }
        });
    };

    render() {
        const { color, minDate, maxDate } = this.props;
        const { startDate, endDate, focusedInput } = this.state;
        const classes = classNames(
            'eds-date-picker',
            'eds-date-picker--inline',
            'eds-date-picker--range',
            `eds-date-picker--${color}`,
        );
        const extraAttrs = getAdditionalProps(this);

        return (
            <div className={classes}>
                <RangePickerController
                    {...extraAttrs}
                    onFocusChange={this._handleFocus}
                    onDatesChange={this._handleDatesChange}
                    focusedInput={focusedInput}
                    startDate={startDate}
                    endDate={endDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    hasDropDown={false}
                />
            </div>
        );
    }
}
